import { Component, OnInit, AfterViewInit, Input, Output, EventEmitter } from '@angular/core';
import { CommonService } from "../common.service";
import { ApiService } from "../api.service";
import { ActivatedRoute, Router } from "@angular/router";
import { AbilityConfig } from "../ability-config/ability-config"
import {PlatformLocation} from '@angular/common';

@Component({
  selector: 'app-case-practice-influence-pro-list',
  templateUrl: './case-practice-influence-pro-list.component.html',
  styleUrls: ['./case-practice-influence-pro-list.component.css', '../../assets/css/font-size.css']
})
export class CasePracticeInfluenceProListComponent implements OnInit, AfterViewInit {
  @Input() practiceList: any;
  @Input() practiceId: any;
  @Input() learningPathId: any;
  @Input() practiceMetaId: any;
  //接受传入的参数 用于判断是否为访客
  @Input() userType: string;
  @Input() type: string;
  @Output() onGoToNextStep = new EventEmitter < any > ();
  @Output() onSetPracticeIndex = new EventEmitter < any > ();
  finished: boolean;
  learningPath: any;
  finishStatus: boolean;
  learningTour: boolean;
  showReport: boolean = false;
  chuanjie: any;
  abilityConfig: AbilityConfig;

  /* 精彩瞬间 */
  showMoment:boolean = false;
  momentList:any = [];
  //学习 metaId
  learningPathMetaId:number = 0;
  //学习meta 列表
  learningPathMetas:any;
  isShowQuestionnaire: boolean = false;
  questionnaireInfo: any = null;
  learningPathSubItems: any;
  isOpenClass: number = 0;
  approachTheme: any = {};
  currentIndex: number = 0;
  isShowApproach: boolean = false;
  isCustomLock: boolean = false;

  projectId: string;
  lock: boolean = false;
  isShowToast: boolean = false;
  promptText: string;
  get showGoToSurveyBtn():boolean{
    return this.practiceList.every(item=>{
      return item.status === 2;
    })
  }
  constructor(
    private commonService: CommonService,
    private apiService: ApiService,
    private platformLocation: PlatformLocation,
    private route: ActivatedRoute,
    private router: Router
  ) {}

  ngOnInit() {
    let temp = true;
    let that = this;
    this.abilityConfig = new AbilityConfig(this.apiService,this.commonService);
    this.isOpenClass = Number(localStorage.getItem("openClass")) ? 1 : 0;
    localStorage.setItem("moduleId","3");
    this.projectId = localStorage.getItem("projectId")
    let projectmsg = JSON.parse(localStorage.getItem('projectmsg'))
    if(this.projectId && projectmsg){
      projectmsg.map(item=>{
        if(item.type == 4 && item.lockType == 1){
          this.lock = item.lock;
          this.promptText = `能力考核将于${item.promptTime}开放。`
        }
      })

    }
    //loadconfig
    this.apiService.loadConfig("./assets/config/practiceList.json").subscribe(result => {
      this.practiceList.forEach(function(item, index) {
        if(result[item.title] != null) {
          item["extends"] = result[item.title];
        }
      });
    });

    this.getLearningTour().then(result=>{
      this.learningPathMetas = result.learning_path_metas;
      this.learningTour = result.pre_survey_meta_ids.length > 0;
    }).then(()=>{
      return this.getOnceinoByPracticeMetaId(this.practiceMetaId).then(result=>{
        return this.finishStatus = result == 1;
      });
    }).then(()=>{
      this.getLearningPathMetaId();
    }).then(()=>{
      return this.getLearningPath(this.learningPathMetaId).then(result=>{
        return this.learningPath = result;
      })
    }).then(()=>{
      return this.getUserQuestionnaireInfo(this.learningPathMetaId).then(result=>{
        return  this.questionnaireInfo = result;
      });
    }).then(()=>{
      //增加学习断点
      this.commonService.addUserBreakPoint({'learningPathMetasId':Number(this.learningPathMetaId),'moduleId':3,'breakpointUrl':this.platformLocation['location']['href'],'projectId':localStorage.getItem("projectId")?localStorage.getItem("projectId") : null}).then();
      this.commonService.setCustomLockDate(this.learningPath,Date());
      this.isCustomLock = this.learningPath.subItems[3].isLock;
      this.isShowQuestionnaire = this.questionnaireInfo && this.questionnaireInfo.length ===0 && this.learningPath.subItems.filter(d=>d.type === 3)[0].progress ===100 && this.learningPath.subItems.filter(d=>d.type === 4)[0].progress!==100 ? true : false;
      for(var i = 0; i <= this.practiceList.length - 1; i++) {
        if(this.practiceList[i].status != 2) {
          temp = false;
        }
      }
      this.finished = temp;

      if(this.finished) {
        $('#surveyBtn').fadeIn(200);
      }
    });


    this.getPracticeToastIndex();
  }

  //获取进度
  getProgress(learningPathMetaId){
    return this.apiService.ajax({
      'type': 'GET',
      'url': 'ddilearner/v2/user/learning/progress?learningPathMetaIds='+String(learningPathMetaId),
    }).toPromise();
  }

  // 获取getOnceinoByPracticeMetaId
  getOnceinoByPracticeMetaId(practiceMetaId){
    return this.abilityConfig.getOnceinoByPracticeMetaId(practiceMetaId).toPromise();
  }

  // 获取learningTour
  getLearningTour(){
    return  this.apiService.ajax({
      'type': 'get',
      'url': '/sr/learningtour',
    }).toPromise();
  }

  //获取用户学习 metaid and version
  getLearningPathMetaId(){
    var that = this;
    this.learningPathMetas.forEach(function(item,i){
      if(item.learningPathId == that.learningPathId){
        if(that.type){
          $('#learningPathMetaIdContainer').val(item.id)
        }
        that.learningPathMetaId = item.id;
      }
    });

    this.getProgress(this.learningPathMetaId).then(result=>{
      //向LMS传递进度
      if(localStorage.getItem("source_env") === "LMS_SCORM"){
        this.commonService.sendDataMessage('type','LMS_LEARN_PROGRESS',result[0].progressList[0].progress,"data");
      }
      return this.currentIndex = result[0]['progressList'][0]['currentItemIndex'] == 4 && result[0]['progressList'][0]['progress'] == 100 ? 5 : result[0]['progressList'][0]['currentItemIndex'] ;
    }).then(()=>{
      this.approachTheme.colorSystem = 'dark';
      this.approachTheme.label = ['能力诊断','课程学习','情景模拟','能力考核'];
      this.approachTheme.currentIndex = that.currentIndex -2;
      this.approachTheme.desc = '离完成只差最后一步了，交出你优秀的答卷吧！';
      this.approachTheme.btnTxt = '开启能力考核';
    }).then(()=>{
      this.isShowApproach = true;
    });
  }

  //获取getLearningPath
  getLearningPath(learningPathMetaId){
    return this.apiService.getOrCreateLearningPath(learningPathMetaId).toPromise();
  }

  ngAfterViewInit() {
    this.commonService.initPage({
      'backgroundColor': 'white'
    });
  }

  goToNextStep(i) {
    localStorage.setItem('influenceProExerciseMetaId', this.practiceList[i].exerciseMetaId);
    // this.commonService.learningPortEventLogByCandy({'learningPathMetaId':this.learningPathMetaId,'module':'进入情景模拟'+(i+1)}).then();
    this.onSetPracticeIndex.emit(i);
    // 如果是访客点击永远从头开始情景模拟
    if(this.userType) {
      this.onGoToNextStep.emit(1);
    } else {
      //正式用户流程
      if(this.practiceList[i].status == 2) {
        let link = ['case-practice-report-new', this.practiceId, this.practiceList[i].id, this.learningPathId];
        if(this.practiceMetaId == 10) {
          link = ['case-practice-report-new-2', this.practiceId, this.practiceList[i].id, this.learningPathId];
        }
        if(this.type){
          this.router.navigate(link,{queryParams:{type:'huatek'}});
        }else{
          this.router.navigate(link);
        }
      } else if(this.practiceMetaId == 10) {
        let link = ['case-practice-hotel', this.practiceId, this.practiceList[i].id, this.learningPathId];
        if(this.type){
          this.router.navigate(link,{queryParams:{type:'huatek'}});
        }else{
          this.router.navigate(link);
        }
      } else if(this.practiceMetaId == 16 && [141, 151].indexOf(this.practiceList[i].exerciseMetaId) > -1) {
        let link = ['case-practice-influence-supplier', this.learningPathId, this.practiceId, this.practiceList[i].id, this.practiceList[i].exerciseMetaId];
        if(this.type){
          this.router.navigate(link,{queryParams:{type:'huatek'}});
        }else{
          this.router.navigate(link);
        }
      }else if(this.practiceMetaId == 607){
        if(this.practiceList[i].exerciseMetaId === 60701){
          this.apiService.ajax({
            'type': 'get',
            'url': '/api/pnoStorePoint/' + this.practiceList[i].id
          }).subscribe(result => {
            if(result.status == 0 || result.status == 5) {
              this.onGoToNextStep.emit(1);
            } else if(result.status == 10) {
              $('#exerciseMetaId').val(this.practiceList[i].exerciseMetaId);
              // let exerciseMetIdNode = document.getElementById("exerciseMetId") as HTMLInputElement
              // exerciseMetIdNode.value = this.practiceList[i].exerciseMetaId
              // console.log(exerciseMetIdNode.value )
              let link = ['case-practice-influence-pro-main', this.learningPathId, this.practiceId, this.practiceList[i].id ];
              if(this.type){
                this.router.navigate(link,{queryParams:{type:'huatek'}});
              }else{
                this.router.navigate(link);
              }
              if(this.practiceList[0].status!==2){
                const exerciseMetaId=$('#exerciseMetaId').val()
                this.apiService.learingTime({learningPathMetaId:localStorage.getItem('learningPathMetaId'),module:"情景模拟",courseUnit:'',type:1,btnName:exerciseMetaId,userId:localStorage.getItem("userId")}).subscribe(result=>{
                  console.log(result)
                })
                console.log(exerciseMetaId)
                this.commonService.sendPostMessage(0,'isPractice' +'Complete')
              }
            }
          });
        }else{
          let link = ['case-practice-influence-supplier', this.learningPathId, this.practiceId, this.practiceList[i].id,this.practiceList[i].exerciseMetaId];
          if(this.type){
            this.router.navigate(link,{queryParams:{type:'huatek'}});
          }else{
            this.router.navigate(link);
          }
        }
      }else {
        this.apiService.ajax({
          'type': 'get',
          'url': '/api/pnoStorePoint/' + this.practiceList[i].id
        }).subscribe(result => {
          if(result.status == 0 || result.status == 5) {
            this.onGoToNextStep.emit(1);
          } else if(result.status == 10) {
            $('#exerciseMetaId').val(this.practiceList[i].exerciseMetaId);
            console.log($('#exerciseMetaId').val(this.practiceList[i].exerciseMetaId))
            let link = ['case-practice-influence-pro-main', this.learningPathId, this.practiceId, this.practiceList[i].id];
            if(this.type){
              this.router.navigate(link,{queryParams:{type:'huatek'}});
            }else{
              this.router.navigate(link);
            }
            if(this.practiceList[0].status!==2){
              const exerciseMetaId=$('#exerciseMetaId').val()
              this.apiService.learingTime({learningPathMetaId:localStorage.getItem('learningPathMetaId'),module:"情景模拟",courseUnit:'',type:1,btnName:exerciseMetaId,userId:localStorage.getItem("userId")}).subscribe(result=>{
                console.log(result)
              })
              console.log(exerciseMetaId)
              this.commonService.sendPostMessage(0,'isPractice' +'Complete')
            }
          }
        });
      }
    }
  }

  goToPostSurvey() {
    if( this.type === 'huatek'){
      this.commonService.sendPostMessage(1,'goPostSurvey')
      return
    }else{
      this.commonService.learningPortEventLogByCandy({'learningPathMetaId':this.learningPathMetaId,'module':'情景模拟','btnName':this.approachTheme.btnTxt,'userId':localStorage.getItem("userId")}).then();
      let link;
      if(this.practiceMetaId == 10) {
        //link = ['survey', this.learningPathId, 13, 1];
        link = ['learning-path', 13];
        this.router.navigate(link);
      }else if(this.practiceMetaId == 16){
        if(this.lock){
          this.prompToast();
          return
        }

        link = ["ability-survey", this.learningPathMetaId, 2];
        this.router.navigate(link);
      }else if(this.practiceMetaId == 607){
        if(this.lock){
          this.prompToast();
          return
        }

        link = ["ability-survey", this.practiceMetaId, 2];
        this.router.navigate(link);
      } else  {
        //link = ['survey', this.learningPathId, 15, 1];
        link = ['learning-path', 15];
        this.router.navigate(link);
      }
    }

  }

  prompToast(){
    this.isShowToast = true;
    setTimeout(()=>{
      this.isShowToast = false;
    },2000);
  }

  finish() {
    if(this.finishStatus) {
      return;
    } else {
      this.abilityConfig.setOnceinoByPracticeMetaId(this.practiceMetaId).subscribe();
      this.goMain();
    }
  }

  goMain() {
    //影响力转向特殊处理
    if(this.practiceMetaId == 9) {
      this.showReport = true;
    } else {
      if(this.learningTour) {
        let link = ['learning-map', 3];
        this.router.navigate(link);
      } else {
        let link = ['learning-map'];
        this.router.navigate(link);
      }
    }

  }

  goLearnPath(pathId) {
    let link = ['learning-path', pathId];
    this.router.navigate(link);
  }
  goLearnPath15() {
    this.goLearnPath(15);
  }

  close() {
    this.apiService.ajax({
      'type': 'get',
      'url': '/ddilearner/v1/getLearningPathMetaId/' + this.learningPathId
    }).subscribe(result => {
      // 只在learningTour里出现，当完成能力是退出进入map
      if((this.finishStatus || !this.finished) && this.learningTour) {
        let link = ['learning-map', 3];
        this.router.navigate(link);
      } else if(!this.finishStatus && this.finished) {
        this.abilityConfig.setOnceinoByPracticeMetaId(this.practiceMetaId).subscribe(result => {
          this.goMain();
        }, error => {
          let link = ['error'];
          this.router.navigate(link);
        });
      } else {
        let link = ["learning-path", result.data];
        this.router.navigate(link);
      }
    });
  }

  //展示难忘瞬间gallary
  momentView(mlist,$event) {
    this.showMoment = true;
    this.momentList = mlist;
    $event.stopPropagation();
  }
  //关闭难忘瞬间gallary
  momentExit(){
    this.showMoment = false;
  }
  //第一次提示的位置
  toastIndex:number = -1;
  getPracticeToastIndex(){
    this.practiceList.forEach((item,i) => {
      if(this.toastIndex == -1 && item.momentsList.length >0){
        this.toastIndex = i;
        return false;
      }
    });
    if(this.toastIndex >= 0){
      this.getShowToastEnable();
    }

  }
  //toast是否提示过
  showToast:boolean = false;
  getShowToastEnable(){
    //type=11-情景模拟难忘瞬间提示
    this.apiService.ajax({
      'type': 'get',
      'url': '/sr/incentiveLine/firstHints/15/12',
    }).subscribe(result => {
      if(result.firstFlag){
        this.showToast = true;
        setTimeout(()=>{
          this.showToast = false;
        },2500);
      }
    });
  }

  closeQuestionnaire(){
    this.isShowQuestionnaire = false;
  }

  //查询用户相应能力满意度
  getUserQuestionnaireInfo(learningPathMetaId){
    return this.apiService.ajax({
      'type': 'GET',
      'url': 'ddilearner/v1/usersSatisficing/learningPathMetaId/' + learningPathMetaId
    }).toPromise();
  }

}



// WEBPACK FOOTER //
// ./src/app/case-practice-influence-pro-list/case-practice-influence-pro-list.component.ts